import { BarChart3, Table2 } from 'lucide-react';
import { useState, type ReactNode } from 'react';
import { IconButton } from './button';
import { Tooltip } from './tooltip';

export interface ChartCardProps {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  /** Tabular alternative for accessibility and audit; every chart card has one. */
  table: ReactNode;
  labels: { viewAsTable: string; viewAsChart: string };
  children: ReactNode;
}

export function ChartCard({ title, subtitle, actions, table, labels, children }: ChartCardProps) {
  const [asTable, setAsTable] = useState(false);
  const toggleLabel = asTable ? labels.viewAsChart : labels.viewAsTable;
  return (
    <section className="rounded-lg border border-border-subtle bg-bg-1 px-4 pt-3 pb-2">
      <header className="mb-2 flex flex-wrap items-center justify-between gap-x-4 gap-y-1">
        <div className="flex items-baseline gap-2">
          <h2 className="text-sm font-medium">{title}</h2>
          {subtitle !== undefined && <span className="text-xs text-text-3">{subtitle}</span>}
        </div>
        <div className="flex items-center gap-3">
          {actions}
          <Tooltip content={toggleLabel}>
            <IconButton
              size="sm"
              label={toggleLabel}
              aria-pressed={asTable}
              onClick={() => {
                setAsTable((v) => !v);
              }}
            >
              {asTable ? <BarChart3 /> : <Table2 />}
            </IconButton>
          </Tooltip>
        </div>
      </header>
      {asTable ? <div className="max-h-80 overflow-auto pb-2">{table}</div> : children}
    </section>
  );
}
